module.exports = __webpack_public_path__ + "static/media/letter.0f607908.png";